<app-access-item [hideOverflow]="true">
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/image-sizes.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Resized Images</span>
  </app-access-item-header>

  <app-access-item-body>
    <app-gallery-settings-customize-button
      (onClick)="customize.emit()"
      location="download-sizes-setting-item"
      [show]="downloadSizes()"
    >
    </app-gallery-settings-customize-button>
  </app-access-item-body>

  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input type="checkbox" id="download-sizes" [(ngModel)]="downloadSizes" (ngModelChange)="updateDownloadSizes()" />
      <label for="download-sizes" data-test-id="download-sizes"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
